/** Vite-Konfiguration im Browser; Regel 12 zu `process.env` gilt für die API. */
const configuredBase: unknown = import.meta.env.VITE_API_BASE_URL;
const baseUrl = (typeof configuredBase === 'string' ? configuredBase : '').replace(/\/$/, '');

export function authUrl(path: string): string {
  return `${baseUrl}/api/auth/${path}`;
}

export interface CurrentSession {
  readonly subject: string;
  readonly name: string;
}

export async function loadSession(): Promise<CurrentSession | null> {
  const response = await fetch(authUrl('me'), { credentials: 'include' });

  if (response.status === 401) {
    return null;
  }

  if (!response.ok) {
    throw new Error('Sitzung konnte nicht geladen werden');
  }

  return (await response.json()) as CurrentSession;
}

export async function logout(): Promise<void> {
  const response = await fetch(authUrl('logout'), {
    method: 'POST',
    credentials: 'include',
  });

  if (response.status !== 204 && response.status !== 401) {
    throw new Error('Abmelden fehlgeschlagen');
  }
}
